import { theme } from '@sg/garnish';

// ─────────────────────────────────────────────────────────────────────────────

export const dialogExitDuration = theme.transitions.short;

export const addedDuration = 1000;
